module.exports = __webpack_public_path__ + "static/media/cts_image2.b84f3776.png";